import Api from './ApiRequest';

export default {
    getAll: (params) => Api.get('/cent/locations', params),
    getById: (id) => Api.get(`/cent/location/${id}`),
    save: (entity) => Api.post('/cent/location', entity),
    update: (id, entity) => Api.put(`/cent/location/${id}`, entity),
    delete: (id) => Api.delete(`/cent/location/${id}`),
    search: (searchText) => Api.get('/cent/locations/search', {q: searchText}),
    getStatuses: () => Api.get('/cent/location/statuses'),
    getAllByVenue: (id) => Api.get(`/cent/locations/venue/${id}`),
    getStats: () => Api.get('/cent/locations/stats'),
    getContacts: (id) => Api.get(`/cent/location/${id}/contacts`),
    addContact: (id, contactId) => Api.put(`/cent/location/${id}/contact`, {contactId: contactId}),
    getEvents: (id, params) => Api.get(`/cent/location/${id}/events`, params),
};
